import { render, staticRenderFns } from "./SmsDetails.vue?vue&type=template&id=83f85a5a&"
import script from "./SmsDetails.vue?vue&type=script&lang=js&"
export * from "./SmsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports